export type Sheet = {
  name: string
  headers: readonly string[]
  rows: readonly (readonly string[])[]
  records: readonly Record<string, unknown>[]
}

export const SHEET_FORMATS = ['csv', 'json', 'md', 'xlsx', 'xml'] as const

export type SheetFormat = (typeof SHEET_FORMATS)[number]
